import React from "react";
import {
  Phone,
  EnvelopeSimple,
  WhatsappLogo,
  InstagramLogo,
  YoutubeLogo,
  XLogo,
  TelegramLogo,
  MapPin,
} from "@phosphor-icons/react";
import Logo from "./Logo";
import { openWhatsapp } from "../lib/whatsapp";

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://instagram.com/mallumarketprofile",
    Icon: InstagramLogo,
    testId: "social-instagram",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@mallumarketprofile",
    Icon: YoutubeLogo,
    testId: "social-youtube",
  },
  {
    name: "X (Twitter)",
    href: "https://x.com/greateaglecap",
    Icon: XLogo,
    testId: "social-x",
  },
  {
    name: "Telegram",
    href: "https://t.me/mallumarketprofile",
    Icon: TelegramLogo,
    testId: "social-telegram",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0A0A0A] text-[#F4F3ED] pt-16 pb-8 border-t border-[#0A0A0A]"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <Logo className="h-12 w-auto" testId="footer-logo" />
              <div className="leading-tight">
                <div className="font-display font-black text-lg">GREAT EAGLE TECH</div>
                <div className="font-mono-acc text-[10px] tracking-[0.25em] text-[#A1A1AA]">
                  MARKET PROFILE · ORDER FLOW
                </div>
              </div>
            </div>
            <p className="font-body text-sm text-[#A1A1AA] leading-relaxed max-w-sm">
              Institutional-grade trading education for the Indian markets. Built
              around the idea that markets move by participation, not prediction.
            </p>

            <div className="mt-6">
              <div className="font-mono-acc text-[10px] tracking-[0.3em] text-[#D9381E] mb-3 uppercase">
                Follow
              </div>
              <div
                className="flex items-center gap-2.5"
                data-testid="social-links"
              >
                {SOCIALS.map(({ name, href, Icon, testId }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={name}
                    title={name}
                    data-testid={testId}
                    className="w-10 h-10 inline-flex items-center justify-center border border-[#2A2A2A] bg-[#0A0A0A] text-[#F4F3ED] hover:bg-[#D9381E] hover:border-[#D9381E] transition-colors"
                  >
                    <Icon size={18} weight="bold" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-acc text-[10px] tracking-[0.3em] text-[#D9381E] mb-4 uppercase">
              Contact
            </div>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5 text-sm">
                <Phone size={16} weight="duotone" className="text-[#D9381E]" />
                <a href="tel:+918129387138" className="hover:text-[#D9381E] transition">
                  +91 81293 87138
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <Phone size={16} weight="duotone" className="text-[#D9381E]" />
                <a href="tel:+918129387137" className="hover:text-[#D9381E] transition">
                  +91 81293 87137
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <EnvelopeSimple size={16} weight="duotone" className="text-[#D9381E]" />
                <a
                  href="mailto:office.greateagle@gmail.com"
                  className="hover:text-[#D9381E] transition"
                >
                  office.greateagle@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <WhatsappLogo size={16} weight="duotone" className="text-[#25D366]" />
                <button
                  onClick={() => openWhatsapp()}
                  className="hover:text-[#25D366] transition cursor-pointer"
                >
                  WhatsApp us
                </button>
              </li>
              <li
                className="flex items-center gap-2.5 text-sm pt-1"
                data-testid="footer-locations"
              >
                <MapPin size={16} weight="duotone" className="text-[#D9381E]" />
                <span>Trivandrum · Bengaluru</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-acc text-[10px] tracking-[0.3em] text-[#D9381E] mb-4 uppercase">
              Disclaimer
            </div>
            <p className="font-body text-xs text-[#A1A1AA] leading-relaxed">
              Great Eagle Tech provides educational and mentorship content. We are
              not SEBI-registered investment advisers. All trading involves risk —
              you alone are responsible for your decisions. Past performance,
              testimonials and screenshots do not guarantee future results.
            </p>
          </div>
        </div>

        <div className="skel-line-dark mb-6" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] text-[#A1A1AA] uppercase">
            © {new Date().getFullYear()} Great Eagle Tech. All rights reserved.
          </div>
          <div className="font-mono-acc text-[10px] tracking-[0.3em] text-[#A1A1AA] uppercase">
            Cohort 15 / 2026 · Commences 31 August 2026
          </div>
        </div>
      </div>
    </footer>
  );
}
